import classNames from "classnames";
import { useSearchParams } from "react-router-dom";
import useRanking from "../hooks/useRanking";
import { ReactComponent as Badge1 } from "../assets/images/badge_1.svg";
import { ReactComponent as Badge2 } from "../assets/images/badge_2.svg";
import { ReactComponent as Badge3 } from "../assets/images/badge_3.svg";
import { ReactComponent as Crown1 } from "../assets/images/crown_1.svg";
import { ReactComponent as Crown2 } from "../assets/images/crown_2.svg";
import { ReactComponent as Crown3 } from "../assets/images/crown_3.svg";
import Header from "../components/Header";
import ReactLoading from "react-loading";
import { useTranslation } from "react-i18next";
import RealtimeSection from "../components/realtime-section";
import Snapshot from "../components/Snapshot";
import get from 'lodash/get';

const LeaderBoard = () => {
  const { data, isTimeout } = useRanking();
  const [searchParams] = useSearchParams();
  const branch_id = searchParams.get("branch_id");
  const token = searchParams.get("token");
  const { t } = useTranslation();

  if (isTimeout) {
    return (
      <>
        <Header />
        <div className="w-full h-full flex flex-col items-center justify-center text-gray-700 font-bold">
          <div className="text-5xl tracking-wider">Session Timeout</div>
          <div className="text-xl mt-4">
            Please click the URL again to access the Leaderboard.
          </div>
        </div>
      </>
    );
  }

  if (!data) {
    return (
      <>
        <Header />
        <div className="w-full h-full flex items-center justify-center">
          <ReactLoading type="spin" color="gray" />
        </div>
      </>
    );
  } else if (data?.rows.length === 0) {
    return (
      <>
        <Header
          data={{
            interval: data.interval || "",
            start: data.start || "",
            end: data.end || "",
            brandName: data.brand_name || "",
            thirdparty: data.contest.third_party_sources || [],
            hideButton: !!token,
          }}
        />
        <div className="text-5xl font-bold text-gray-700 leading-none w-full h-full flex items-center justify-center">
          All Store Closed
        </div>
      </>
    );
  }

  return (
    <>
      <Header
        data={{
          interval: data.interval || "",
          start: data.start || "",
          end: data.end || "",
          brandName: data.brand_name || "",
          thirdparty: data.contest.third_party_sources || [],
          hideButton: !!token,
        }}
      />
      <div className="flex text-center px-4 pb-4 h-full">
        <div className="flex-1">
          {data.contest.third_party_sources.length > 0 ? (
            <>
              <div className="grid grid-cols-3 py-2 text-xs leading-4 font-bold text-gray-700">
                <div />
                <div>Current Daypart</div>
                <div>Current Day</div>
              </div>
              <div className="grid grid-cols-3">
                <div />
                <div className="grid grid-cols-3 text-xs leading-4 font-semibold text-white">
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">
                    Cars
                  </div>
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">
                    Lane Total
                  </div>
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">
                    Goal Meet %
                  </div>
                </div>
                <div className="grid grid-cols-3 text-xs leading-4 font-semibold text-white">
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">
                    Cars
                  </div>
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">
                    Lane Total
                  </div>
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">
                    Goal Meet %
                  </div>
                </div>
              </div>
              <div>
                {data?.rows.map((row, i) => {
                  const isActive = row.branch_id === branch_id;

                  return (
                    <div
                      key={i}
                      className={classNames("overflow-hidden", {
                        "rounded-t-lg": i === 0,
                        "rounded-b-lg": i === data.rows.length - 1,
                        "shadow-[0_0_15px_rgba(0,0,0,0.25)] scale-100":
                          isActive,
                      })}
                    >
                      <div
                        className={classNames(
                          "grid grid-cols-3 bg-white border-gray-300 text-gray-700 h-[32px] items-center",
                          {
                            "border-b": i < data.rows.length - 1,
                            "border-b-2 border-gray-400":
                              (data.rows.length > 3 && i === 2) ||
                              (data.rows.length > 6 && i === 5),
                            "text-lg leading-7 font-bold": isActive,
                            "text-sm leading-5 font-semibold": !isActive,
                          }
                        )}
                      >
                        <div className="h-full flex items-center">
                          <div className="w-16 flex items-center justify-center">
                            {(() => {
                              switch (i) {
                                case 0:
                                  return (
                                    <Badge1
                                      className={classNames("h-[24px]")}
                                    />
                                  );
                                case 1:
                                  return (
                                    <Badge2
                                      className={classNames("h-[24px]")}
                                    />
                                  );
                                case 2:
                                  return (
                                    <Badge3
                                      className={classNames("h-[24px]")}
                                    />
                                  );
                                default:
                                  return row.rank;
                              }
                            })()}
                          </div>
                          <div
                            className={classNames(
                              "flex items-center truncate",
                              {
                                "text-lg leading-7 font-bold": i < 3,
                              }
                            )}
                          >
                            {row.branch_name}
                            {(() => {
                              switch (i) {
                                case 0:
                                  return (
                                    <Crown1
                                      className={classNames(
                                        "h-[24px] flex-shrink-0"
                                      )}
                                    />
                                  );
                                case 1:
                                  return (
                                    <Crown2
                                      className={classNames(
                                        "h-[24px] flex-shrink-0"
                                      )}
                                    />
                                  );
                                case 2:
                                  return (
                                    <Crown3
                                      className={classNames(
                                        "h-[24px] flex-shrink-0"
                                      )}
                                    />
                                  );
                                default:
                                  return null;
                              }
                            })()}
                          </div>
                        </div>
                        <div className="h-full items-center justify-center grid grid-cols-3 border-x border-gray-300">
                          <div>{row.data["dayparts_production_count"]}</div>
                          <div className="flex h-full items-center justify-center bg-[#FEF2F2] gap-1">
                            <span
                              style={{
                                color:
                                  String(
                                    row.data["dayparts_service_goal_color"]
                                  ) ?? "gray",
                              }}
                            >
                              {row.data["dayparts_service"]}
                            </span>{" "}
                            / {row.data["dayparts_service_goal"]}
                          </div>
                          <div>
                            {row.data["dayparts_service_goal_meet_percentage"]}
                          </div>
                        </div>
                        <div className="h-full items-center justify-center grid grid-cols-3">
                          <div>{row.data["1day_production_count"]}</div>
                          <div>
                            <span
                              style={{
                                color:
                                  String(row.data["1day_service_goal_color"]) ??
                                  "gray",
                              }}
                            >
                              {row.data["1day_service"]}
                            </span>{" "}
                            / {row.data["1day_service_goal"]}
                          </div>
                          <div>
                            {row.data["1day_service_goal_meet_percentage"]}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          ) : data.contest.layout === 'drivethru' ? (
            <>
              <div className="grid grid-cols-3 py-2 text-xs leading-4 font-bold text-gray-700">
                <div />
                <div>{t(`contest.table_time_frame_title.${data.contest.table_time_frame_title[0]}`)}</div>
                <div>{t(`contest.table_time_frame_title.${data.contest.table_time_frame_title[1]}`)}</div>
              </div>
              <div className="grid grid-cols-3">
                <div />
                <div className="grid grid-cols-3 text-xs leading-4 font-semibold text-white">
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">
                    {t(`contest.table_metric_title.${data.contest.table_metric_title[0]}`)}
                  </div>
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">
                    {t(`contest.table_metric_title.${data.contest.table_metric_title[1]}`)}
                  </div>
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">
                    {t(`contest.table_metric_title.${data.contest.table_metric_title[2]}`)}
                  </div>
                </div>
                <div className="grid grid-cols-3 text-xs leading-4 font-semibold text-white">
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">
                    {t(`contest.table_metric_title.${data.contest.table_metric_title[3]}`)}
                  </div>
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">
                    {t(`contest.table_metric_title.${data.contest.table_metric_title[4]}`)}
                  </div>
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">
                    {t(`contest.table_metric_title.${data.contest.table_metric_title[5]}`)}
                  </div>
                </div>
              </div>
              <div>
                {data?.rows.map((row, i) => {
                  const isActive = row.branch_id === branch_id;

                  return (
                    <div
                      key={i}
                      className={classNames("overflow-hidden", {
                        "rounded-t-lg": i === 0,
                        "rounded-b-lg": i === data.rows.length - 1,
                        "shadow-[0_0_15px_rgba(0,0,0,0.25)] scale-100":
                          isActive,
                      })}
                    >
                      <div
                        className={classNames(
                          "grid grid-cols-3 bg-white border-gray-300 text-gray-700 h-[32px] items-center",
                          {
                            "border-b": i < data.rows.length - 1,
                            "border-b-2 border-gray-400":
                              (data.rows.length > 3 && i === 2) ||
                              (data.rows.length > 6 && i === 5),
                            "text-lg leading-7 font-bold": isActive,
                            "text-sm leading-5 font-semibold": !isActive,
                          }
                        )}
                      >
                        <div className="h-full flex items-center">
                          <div className="w-16 flex items-center justify-center">
                            {(() => {
                              switch (i) {
                                case 0:
                                  return (
                                    <Badge1
                                      className={classNames("h-[24px]")}
                                    />
                                  );
                                case 1:
                                  return (
                                    <Badge2
                                      className={classNames("h-[24px]")}
                                    />
                                  );
                                case 2:
                                  return (
                                    <Badge3
                                      className={classNames("h-[24px]")}
                                    />
                                  );
                                default:
                                  return row.rank;
                              }
                            })()}
                          </div>
                          <div
                            className={classNames(
                              "flex items-center truncate",
                              {
                                "text-lg leading-7 font-bold": i < 3,
                              }
                            )}
                          >
                            {row.branch_name}
                            {(() => {
                              switch (i) {
                                case 0:
                                  return (
                                    <Crown1
                                      className={classNames(
                                        "h-[24px] flex-shrink-0"
                                      )}
                                    />
                                  );
                                case 1:
                                  return (
                                    <Crown2
                                      className={classNames(
                                        "h-[24px] flex-shrink-0"
                                      )}
                                    />
                                  );
                                case 2:
                                  return (
                                    <Crown3
                                      className={classNames(
                                        "h-[24px] flex-shrink-0"
                                      )}
                                    />
                                  );
                                default:
                                  return null;
                              }
                            })()}
                          </div>
                        </div>
                        <div className="h-full items-center justify-center grid grid-cols-3 border-x border-gray-300">
                          <div>{get(row.data, data.type[0])}</div>
                          <div className="flex h-full items-center justify-center bg-[#FEF2F2] gap-1">
                            <span
                              style={{
                                color: get(row.data, `${data.type[2]}_color`) ?
                                    String(get(row.data, `${data.type[2]}_color`)) : 
                                    "gray",
                              }}
                            >
                              {get(row.data, data.type[1])}
                            </span>{" "}
                            / {get(row.data, data.type[2])}
                          </div>
                          <div>
                            {get(row.data, data.type[3])}
                          </div>
                        </div>
                        <div className="h-full items-center justify-center grid grid-cols-3">
                          <div>{get(row.data, data.type[4])}</div>
                          <div>
                            <span
                              style={{
                                color:
                                  get(row.data, `${data.type[6]}_color`) ?
                                    String(get(row.data, `${data.type[6]}_color`)) : 
                                    "gray",
                              }}
                            >
                              {get(row.data, data.type[5])}
                            </span>{" "}
                            / {get(row.data, data.type[6])}
                          </div>
                          <div>
                            {get(row.data, data.type[7])}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <>
              <div className="grid grid-cols-[2fr_1fr_1fr] py-2 text-xs leading-4 font-bold text-gray-700">
                <div />
                <div>Current Day</div>
                <div>Current Daypart</div>
              </div>
              <div className="grid grid-cols-[2fr_1fr_1fr]">
                <div />
                <div className="grid grid-cols-1 text-xs leading-4 font-semibold text-white">
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">Total Service</div>
                </div>
                <div className="grid grid-cols-1 text-xs leading-4 font-semibold text-white">
                  <div className="mx-2 flex items-center justify-center bg-red-main rounded-t-lg py-1">Total Service</div>
                </div>
              </div>
              <div>
                {data?.rows.map((row, i) => {
                  const isActive = row.branch_id === branch_id;

                  return (
                    <div key={i}
                      className={classNames("overflow-hidden", {
                        "rounded-t-lg": i === 0,
                        "rounded-b-lg": i === data.rows.length-1,
                        "shadow-[0_0_15px_rgba(0,0,0,0.25)] scale-100": isActive
                      })}>
                      <div className={classNames("grid grid-cols-[2fr_1fr_1fr] bg-white border-gray-300 text-gray-700 h-[45px] items-center", {
                        'border-b': i < data.rows.length-1,
                        'border-b-2 border-gray-400': (data.rows.length > 3 && i === 2) || (data.rows.length > 6 && i === 5),
                        'text-xl leading-7 font-bold': isActive,
                        'text-lg leading-5 font-semibold': !isActive,
                      })}>
                        <div className="h-full flex items-center">
                          <div className="w-16 flex items-center justify-center text-sm">
                            {(() => {
                              switch (i) {
                              case 0:
                                return <Badge1 className={classNames("h-[24px]")} />;
                              case 1:
                                return <Badge2 className={classNames("h-[24px]")} />;
                              case 2:
                                return <Badge3 className={classNames("h-[24px]")} />;
                              default:
                                return row.rank;
                              }
                            })()}
                          </div>
                          <div className={classNames("flex items-center truncate", {
                            'text-lg leading-7 font-bold': i < 3,
                          })}>{row.branch_name}
                            {(() => {
                              switch (i) {
                              case 0:
                                return <Crown1 className={classNames("h-[24px] flex-shrink-0")} />;
                              case 1:
                                return <Crown2 className={classNames("h-[24px] flex-shrink-0")} />;
                              case 2:
                                return <Crown3 className={classNames("h-[24px] flex-shrink-0")} />;
                              default:
                                return null;
                              }
                            })()}
                          </div>
                        </div>
                        <div className="h-full flex items-center justify-center border-x border-gray-300">
                          <div className="flex h-full w-full items-center justify-center bg-[#FEF2F2]">{row.data[data.type[0]]}</div>
                        </div>
                        <div className="h-full flex items-center justify-center">
                          <div>{row.data[data.type[1]]}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
        {data.contest.layout === 'counter' && (
          <div className="flex flex-col justify-between w-[378px] mt-4 ml-4">
            <div className="text-gray-700">
              {data.summary_rows.map((row, i) => (
                <div
                  key={i}
                  className="bg-white shadow-md rounded-lg flex flex-col justify-center mb-2"
                >
                  <div className="text-xl leading-7 font-medium">
                    {t(row.type)}
                  </div>
                  <div
                    className={classNames(
                      "grid grid-cols-3 text-6xl leading-none font-bold items-end",
                      {
                        "text-[#16A34A]": row.color === "G",
                        "text-[#F59E0B]": row.color === "O",
                        "text-[#FF3D43]": row.color === "R",
                      }
                    )}
                  >
                    <div />
                    <div data-testid="rolling_hour_avg_total_service_count">
                      {row.value}
                    </div>
                    <div className="text-left text-2xl">
                      {row.sample_size_threshold !== null && (
                        <span
                          className="text-sm text-gray-600"
                          data-testid="sample_size"
                        >
                          {`(sample size <${row.sample_size_threshold})`}
                        </span>
                      )}
                    </div>
                  </div>
                  <div
                    className="text-sm leading-5 font-bold"
                    data-testid="rolling_hour_avg_total_service_goal"
                  >
                    Goal: {row.goal}
                  </div>
                </div>
              ))}
            </div>
            <div className="flex-1 mb-2">
              <Snapshot />
            </div>
            <div className="flex h-[128px]">
              <div className="flex-1">
                {data.contest.realtime_sections.length > 0 && <RealtimeSection />}
              </div>
              <div className="w-[100px] ml-2">
                <div className="text-gray-700 text-xs tracking-tighter leading-3 mb-[2px]">
                  <div>Scan the QR code</div>
                  <div className="text-[10px]">to get in touch with us!</div>
                </div>
                <div>
                  <img
                    alt="qr_code_image"
                    src="./qr_code_image.png"
                    data-testid="qr_code_image"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default LeaderBoard;
